__turbopack_context__.v({
  "accordionSlideOverwrite": "registrationModal-module-scss-module__22IZgG__accordionSlideOverwrite",
  "captchaDisclaimer": "registrationModal-module-scss-module__22IZgG__captchaDisclaimer",
  "content": "registrationModal-module-scss-module__22IZgG__content",
  "fadeIn": "registrationModal-module-scss-module__22IZgG__fadeIn",
  "fadeOut": "registrationModal-module-scss-module__22IZgG__fadeOut",
  "footer": "registrationModal-module-scss-module__22IZgG__footer",
  "header": "registrationModal-module-scss-module__22IZgG__header",
  "logInForm": "registrationModal-module-scss-module__22IZgG__logInForm",
  "overlay": "registrationModal-module-scss-module__22IZgG__overlay",
  "registrationModal": "registrationModal-module-scss-module__22IZgG__registrationModal",
  "scaleIn": "registrationModal-module-scss-module__22IZgG__scaleIn",
  "scaleOut": "registrationModal-module-scss-module__22IZgG__scaleOut",
  "submitButton": "registrationModal-module-scss-module__22IZgG__submitButton",
  "success": "registrationModal-module-scss-module__22IZgG__success",
  "title": "registrationModal-module-scss-module__22IZgG__title",
  "zoomIn": "registrationModal-module-scss-module__22IZgG__zoomIn",
  "zoomOut": "registrationModal-module-scss-module__22IZgG__zoomOut",
});
